import clsx from 'clsx'
import React, { MouseEventHandler, PropsWithChildren } from 'react'
import { Loader } from '@components/foundation/loader/Loader'
import styles from './styles/Button.module.scss'

export type ButtonProps = {
  onClick?: () => void
  onMouseEnter?: MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>
  variant?: 'contained' | 'outlined'
  color?: 'primary' | 'secondary' | 'tertiary'
  size?: 'small' | 'medium' | 'big'
  disabled?: boolean
  isLoading?: boolean
  style?: React.CSSProperties
  className?: string
  type?: 'button' | 'submit' | 'reset'
  form?: string
  id?: string
} & PropsWithChildren

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const {
    onClick,
    onMouseEnter,
    className,
    children,
    style,
    variant = 'contained',
    color = 'primary',
    disabled,
    isLoading,
    size = 'medium',
    ...rest
  } = props

  const handleClick = () => {
    onClick?.()
  }

  return (
    <button
      ref={ref}
      className={clsx(styles.button, styles[variant], styles[color], styles[size], className)}
      onClick={handleClick}
      onMouseEnter={onMouseEnter}
      style={style}
      disabled={Boolean(disabled || isLoading)}
      data-variant={variant}
      data-color={color}
      data-disabled={disabled || isLoading}
      {...rest}
    >
      {isLoading && <Loader variant={variant === 'outlined' && !disabled ? 'dark' : 'light'} />}
      {children}
    </button>
  )
})
